import { render, staticRenderFns } from "./AddCustomerCredit.vue?vue&type=template&id=4a923050&"
import script from "./AddCustomerCredit.vue?vue&type=script&lang=js&"
export * from "./AddCustomerCredit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports